<template>
    <li>
    <router-link
        :to="{ name: '' }"
        class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-primary-color dark:hover:text-white"
    >
      <i data-feather="grid" class="size-4 me-2"></i>Dashboard
    </router-link>
  </li>
  <li>
    <router-link
        :to="{ name: 'EmployerCompanySetting' }"
        class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-primary-color dark:hover:text-white"
    >
      <i data-feather="home" class= "size-4 me-2"></i>My Company
    </router-link>
  </li>
  <li>
    <router-link
        :to="{ name: '' }"
        class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-primary-color dark:hover:text-white"
    >
      <i data-feather="briefcase" class="size-4 me-2"></i>My Jobs
    </router-link>
  </li>
  <li>
    <router-link
        :to="{ name: 'Message' }"
        class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-primary-color dark:hover:text-white"
    >
      <i data-feather="message-circle" class="size-4 me-2"></i>Messaging
    </router-link>
  </li>
</template>
<script setup lang="ts"></script>
